import type { API } from 'chessboard/api/config/types';

/**
 * Create the getFen method.
 */
export function createGetFen(context: API.Context) {
  /**
   * Get the FEN of the currently selected position.
   */
  return function getFEN(): string {
    const { game } = context;

    return game.fen();
  };
}
